import React from 'react'

export default function About() {
  return (
    <div className='page-content-about'>
        <div>
            <div className='d-flex flex-column justify-content-center align-items-center pt-3 px-3'>
                <h2> Welcome to LittleKai</h2>
                <p>Designed for Year 2+ children, our site offers fun, engaging activities to support learning and development. Explore, play, and grow!</p>
            </div>
            
        </div>
        <div className='d-flex flex-column justify-content-center align-items-center pt-3 px-3'>
            <img className="rounded" height={400} width={200} src='./images/polar-bear.png' alt='polarbear'/>
        </div>
    </div>
    )
}
